<template>
    <div>
       <router-view />
    </div>
</template>

<script>
export default {
  name: 'ProfileLayout'
}
</script>



// WEBPACK FOOTER //
// src/components/App/ProfileLayout.vue